export class FileDownloader {
	#arraybuffer;
	#mimetype;
	#filename;

	constructor(arraybuffer, mimetype, filename) {
		this.#arraybuffer = arraybuffer;
		this.#mimetype = mimetype;
		this.#filename = filename;
	}

	execute() {
		let blob = new Blob([this.#arraybuffer], { type: this.#mimetype}),
			url = window.URL.createObjectURL(blob);

		let a = document.createElement('a');
		document.body.appendChild(a);
		a.style.display = 'none';
		a.href = url;
		a.download = this.#filename;
		a.click();
		window.URL.revokeObjectURL(url);
	}
}
